// extracted by mini-css-extract-plugin
export default {"hud-panel":"hud_hud-panel__RGv+E","game-hud":"hud_game-hud__ixBSu","slot-container":"hud_slot-container__BThgs","result-hud-slot":"hud_result-hud-slot__n4T0C"};